// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "汽轮机设备故障诊断及前沿技术",
      "tec": "孟召军",
      "week": "1-7,9周",
      "add": "教学楼B座420能动"
    },
    {
      "sub": "集控运行",
      "tec": "崔长春",
      "week": "1-7,9-11周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "就业创业指导",
      "tec": "马嘉阳",
      "week": "9-11,15-16周",
      "add": "教学楼B座220能动"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "热力发电厂",
      "tec": "孟召军",
      "week": "1-7,9-11周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "汽轮机原理",
      "tec": "赵傲白羽",
      "week": "1-7,9-11,15-16周",
      "add": "教学楼B座220能动"
    },
    {
      "sub": "水轮机设备及运行",
      "tec": "高宇赵傲",
      "week": "1,3-7,9-10周",
      "add": "教学楼B座319能动"
    },
    [
      {
        "sub": "能源经济基础",
        "tec": "马铭婧",
        "week": "1-7,9周",
        "add": "教学楼B座325能动"
      },
      {
        "sub": "垃圾焚烧发电技术",
        "tec": "王树群",
        "week": "10-11,15-16周",
        "add": "教学楼B座319能动"
      }
    ],
    0
  ],
  "3": [
    {
      "sub": "集控运行",
      "tec": "崔长春",
      "week": "1-7,9-11周",
      "add": "教学楼B座220能动"
    },
    {
      "sub": "电厂自动控制系统",
      "tec": "崔长春",
      "week": "1-7,9周",
      "add": "教学楼B座220能动"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "垃圾焚烧发电技术",
      "tec": "王树群",
      "week": "10-11,15-16周",
      "add": "教学楼B座319能动"
    },
    {
      "sub": "汽轮机原理",
      "tec": "赵傲白羽",
      "week": "1-7,9-11,15-16周",
      "add": "教学楼B座317能动"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "电厂自动控制系统",
      "tec": "崔长春",
      "week": "1-7,9周",
      "add": "教学楼B座220能动"
    },
    {
      "sub": "热力发电厂",
      "tec": "孟召军",
      "week": "1-7,9-11周",
      "add": "教学楼B座220能动"
    },
    {
      "sub": "人工智能概论",
      "tec": "李东明",
      "week": "1-7,9周",
      "add": "教学楼B座220能动"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
